import React from 'react';

import '../styles/auth.css';

interface CloseButtonProps {
  onClick: () => void;
  ariaLabel?: string;
}

export const CloseButton: React.FC<CloseButtonProps> = ({ onClick, ariaLabel = 'Close modal' }) => (
  <button className="auth-close-button" onClick={onClick} aria-label={ariaLabel}>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
  </button>
);
